import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Seed script to populate Firestore with initial campaign data
 * Run this once to set up the database with 4 demo campaigns
 */

const campaignsData = [
  {
    brandName: 'Wolt',
    brandLogo: '/images/wolt.png',
    title: 'Vind gratis levering fra Wolt',
    description: 'Spil og vind gratis levering',
    category: 'Mad',
    imageUrl: '/images/pic-1.png',
    iframeUrl: 'https://ulriklassendk-aps.campaign.playable.com/hvilken-ulrik-er-du?iframe=dontbreakout',
    iframeScript: 'https://app.playable.com/campaign/sdk/utilities.responsive_iframe.min.js',
    prizeTitle: 'Gratis levering',
    prizeValue: '1x gratis levering fra Wolt',
    isActive: true,
    createdAt: serverTimestamp(),
    priority: 1
  },
  {
    brandName: 'FCK Parken',
    brandLogo: '/images/sponsor.png',
    title: 'Vind hotdog på FCK, Parken',
    description: 'Spil og vind en hotdog',
    category: 'Sport',
    imageUrl: '/images/pic-2.png',
    iframeUrl: 'https://ulriklassendk-aps.campaign.playable.com/hvilken-ulrik-er-du?iframe=dontbreakout',
    iframeScript: 'https://app.playable.com/campaign/sdk/utilities.responsive_iframe.min.js',
    prizeTitle: '1x Hotdog',
    prizeValue: '1x Hotdog at FCK, Parken',
    isActive: true,
    createdAt: serverTimestamp(),
    priority: 2
  },
  {
    brandName: 'Beauty Brand',
    brandLogo: '/images/joe.png',
    title: 'Vind skønhedsprodukter',
    description: 'Spil og vind beauty produkter',
    category: 'Beauty',
    imageUrl: '/images/pic-3.png',
    iframeUrl: 'https://ulriklassendk-aps.campaign.playable.com/hvilken-ulrik-er-du?iframe=dontbreakout',
    iframeScript: 'https://app.playable.com/campaign/sdk/utilities.responsive_iframe.min.js',
    prizeTitle: 'Beauty pakke',
    prizeValue: 'Beauty produkter',
    isActive: true,
    createdAt: serverTimestamp(),
    priority: 3
  },
  {
    brandName: 'Fashion Brand',
    brandLogo: '/images/burger.png',
    title: 'Vind gavekort til tøj',
    description: 'Spil og vind gavekort',
    category: 'Tøj',
    imageUrl: '/images/botn-1.png',
    iframeUrl: 'https://ulriklassendk-aps.campaign.playable.com/hvilken-ulrik-er-du?iframe=dontbreakout',
    iframeScript: 'https://app.playable.com/campaign/sdk/utilities.responsive_iframe.min.js',
    prizeTitle: 'Gavekort',
    prizeValue: '200 kr gavekort',
    isActive: true,
    createdAt: serverTimestamp(),
    priority: 4
  }
];

export const seedCampaigns = async () => {
  console.log('🌱 Starting campaign seeding...');
  
  try {
    const campaignsRef = collection(db, 'campaigns');
    
    for (const campaign of campaignsData) {
      const docRef = await addDoc(campaignsRef, campaign);
      console.log(`✅ Campaign "${campaign.brandName}" added with ID: ${docRef.id}`);
    }
    
    console.log('🎉 Campaign seeding completed successfully!');
    console.log(`📊 Total campaigns added: ${campaignsData.length}`);
    
  } catch (error) {
    console.error('❌ Error seeding campaigns:', error);
    throw error;
  }
};

// Uncomment to run directly (for testing purposes)
// seedCampaigns().then(() => {
//   console.log('Seeding finished');
//   process.exit(0);
// }).catch(err => {
//   console.error('Seeding failed:', err);
//   process.exit(1);
// });

